

























import Vue, { PropType } from 'vue';
import store from '@/store';

import { BasePacket } from '@/models/packet';
import { WebRequestStatus } from '@/models';
import * as Utils from '@/utils';

import PacketCard from '@/components/PacketCard.vue';
import PersistableItem from '@/components/PersistableItem.vue';

export default Vue.extend({
  components: {
    PacketCard,
    PersistableItem
  },

  props: {
    packets: {
      type: Array as PropType<BasePacket[]>,
      required: true
    },
    peerGroupId: {
      type: Number,
      required: true
    },
    editing: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      removingStatusMap: {} as {
        [key: number]: { statusTrackerId: number };
      }
    };
  },

  computed: {
    packetStatus(): [BasePacket, WebRequestStatus][] {
      return this.packets
        .slice()
        .sort(Utils.sortNamed)
        .map(p => [
          p,
          store.state.org.activeRequests.associate.getStatus(
            this.removingStatusMap[p.packetId]?.statusTrackerId
          ) || WebRequestStatus.READY
        ]);
    }
  },

  methods: {
    removePacket(packet: BasePacket) {
      const statusTrackerId = Utils.idGenerator.next();

      this.removingStatusMap = {
        ...this.removingStatusMap,
        [packet.packetId]: { statusTrackerId }
      };

      store.dispatch.org.removePacketPeerGroupConnection({
        tempAssociateId: statusTrackerId,
        peerGroupId: this.peerGroupId,
        packetId: packet.packetId
      });
    }
  }
});
